
(function () {
  'use strict';
  angular.module('vcutils.vcshare')
    .component('shareeditor', {
      restrict: 'E',
      bindings: {
        share: '<?',
        shareid: '<?'
      },
      template: `
        <shareform share="vm.share" parentsave="vm.childsave(share)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Netzlaufwerk erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einers neuen Netzlaufwerks wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Netzlaufwerk konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Share', 'Rlog',
        function ($log, Share, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.share) || !vm.share.hasOwnProperty('_id'))
              && angular.isDefined(vm.shareid)) {
              Share.$find(vm.shareid).$then(function (share) {
                vm.share = share;
              }, function (err) {
                $log.error('share not found, id: ', vm.shareid);
                Rlog.error('share', 'shareeditor', 'share not found', {_id: vm.shareid});
              });
            }
          };
          
          function childsave(share) {
            // vm.share = angular.copy(share);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in share) {
              if (share.hasOwnProperty(key)) {
                vm.share[key] = share[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.share.$hasPendingActions()) {
              vm.share.$cancel();
              vm.share.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of share failed: ', err);
                Rlog.error('vcutils.share', 'shareeditor', 'Saving of share failed: ', {error: err, shareid: vm.share._id});
              });
            }
            else {
              vm.share.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of share failed: ', err);
                Rlog.error('vcutils.share', 'shareeditor', 'Saving of share failed: ', {error: err, shareid: vm.share._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());
